var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "app-main-inner",
      staticStyle: { display: "flex", "flex-direction": "column" },
      attrs: {
        "element-loading-text": "",
        "element-loading-spinner": "none",
        "element-loading-background": "rgba(170,170,170,0)"
      }
    },
    [
      _c("div", { staticClass: "app-main-inner-row" }, [
        _c("div", { staticClass: "filters" }),
        _c(
          "div",
          { staticClass: "triggers" },
          [
            !_vm.isEdit
              ? [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.toAddTracking }
                    },
                    [_vm._v(_vm._s(_vm.$t("SystemMaintenance.CreateStatus")))]
                  ),
                  _c("el-button", { attrs: { type: "primary" } }, [
                    _vm._v(_vm._s(_vm.$t("SystemMaintenance.Edit")))
                  ]),
                  _c("el-button", { attrs: { type: "danger" } }, [
                    _vm._v(_vm._s(_vm.$t("SystemMaintenance.Delete")))
                  ])
                ]
              : [
                  _c("el-button", { attrs: { type: "primary" } }, [
                    _vm._v(_vm._s(_vm.$t("SystemMaintenance.Save")))
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.toCancelSaveTracking }
                    },
                    [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Cancel")))]
                  )
                ]
          ],
          2
        )
      ]),
      _c(
        "div",
        { staticClass: "app-main-inner-row" },
        [
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("SystemMaintenance.CreateStatus")))
                ])
              ]),
              _c(
                "el-form",
                {
                  ref: "trackingForm",
                  staticStyle: { width: "100%" },
                  attrs: { "label-position": "left", "label-width": "90px" }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SystemMaintenance.SerialNumber") }
                    },
                    [
                      _c("el-input-number", {
                        attrs: { "controls-position": "right" },
                        model: {
                          value: _vm.trackingForm.level,
                          callback: function($$v) {
                            _vm.$set(_vm.trackingForm, "level", $$v)
                          },
                          expression: "trackingForm.level"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SystemMaintenance.Code") } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.trackingForm.code,
                          callback: function($$v) {
                            _vm.$set(_vm.trackingForm, "code", $$v)
                          },
                          expression: "trackingForm.code"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SystemMaintenance.ChineseName") }
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.trackingForm.codeCname,
                          callback: function($$v) {
                            _vm.$set(_vm.trackingForm, "codeCname", $$v)
                          },
                          expression: "trackingForm.codeCname"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SystemMaintenance.EnglishName") }
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.trackingForm.codeEname,
                          callback: function($$v) {
                            _vm.$set(_vm.trackingForm, "codeEname", $$v)
                          },
                          expression: "trackingForm.codeEname"
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-form-item", {
                    attrs: { label: _vm.$t("SystemMaintenance.NodeType") }
                  }),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SystemMaintenance.NodeType") } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.trackingForm.published,
                            callback: function($$v) {
                              _vm.$set(_vm.trackingForm, "published", $$v)
                            },
                            expression: "trackingForm.published"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SystemMaintenance.PublicOrNot"))
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "OFFSETDAY" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.trackingForm.offsetDay,
                          callback: function($$v) {
                            _vm.$set(_vm.trackingForm, "offsetDay", $$v)
                          },
                          expression: "trackingForm.offsetDay"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "OFFSETHOUR" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.trackingForm.offsetHour,
                          callback: function($$v) {
                            _vm.$set(_vm.trackingForm, "offsetHour", $$v)
                          },
                          expression: "trackingForm.offsetHour"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SystemMaintenance.Remark") } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea", rows: 3 },
                        model: {
                          value: _vm.trackingForm.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.trackingForm, "remark", $$v)
                          },
                          expression: "trackingForm.remark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }